import BackArrow from "../../public/icons/mycoach-backarrow.svg";
import NOCourses from "../../public/icons/no_courses.jpg";
import actions from '../../redux/actions';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';

function ProgramDetails(props) {
    const { university, onBack, program } = props;
    const userId = localStorage.getItem("user_id");
    const [enrollment, setEnrollment] = useState(null);
    const { universityCourseEnrollment } = props;

    const courseEnrollment = async (user_id, program_id,enroll_status) => {
        


        try {
            const courseEnrollmentResp = await universityCourseEnrollment(user_id, program_id,enroll_status);
            if (courseEnrollmentResp?.data) {
                setEnrollment(courseEnrollmentResp.data);
            } else {
                setEnrollment(null);
            }
        } catch (error) {
            console.error("Error fetching college info:", error);
            setEnrollment(null);
        }
    };


    return (
        <div
            style={{ minHeight: "50vh", backgroundColor: "#f9fafb", padding: "20px" }}
        >
            <div
                style={{
                    maxWidth: "1280px",
                    margin: "0 auto",
                    display: "grid",
                    gap: "20px",
                    gridTemplateColumns: "1fr 1fr",
                }}
            >

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        textAlign: "left",
                    }}
                >

                    <div
                        className="heading_button flex"
                        style={{ display: "flex", gap: "10px", alignItems: "center" }}
                    >
                        <div
                            style={{
                                backgroundColor: "white",
                                height: "23px",
                                width: "23px",
                            }}
                        >
                            <a onClick={onBack} href="#">
                                <img
                                    src={BackArrow}
                                    style={{ filter: "invert(1)", padding: "3px" }}
                                    alt="Back"
                                />
                            </a>
                        </div>
                        <h1
                            style={{
                                fontSize: "2rem",
                                fontWeight: "bold",
                                marginBottom: "8px",
                            }}
                        >
                            {university?.name || "University Details"}
                        </h1>
                    </div>

                    {
                        program && <div style={{ marginBottom: "20px" }}>
                            <p
                                style={{
                                    fontSize: "1.125rem",
                                    color: "#6b7280",
                                    fontWeight: "500",
                                }}
                            >
                                {program.label || "Program Name"}
                            </p>
                            


                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "baseline",
                                    gap: "8px",
                                }}
                            >
                                <span style={{ fontSize: "2rem", fontWeight: "bold" }}>
                                    {program.price || "$0.0"}
                                </span>
                                {program.discountPrice && (
                                    <>
                                        <span
                                            style={{
                                                fontSize: "1rem",
                                                color: "#6b7280",
                                                textDecoration: "line-through",
                                            }}
                                        >
                                            {program.discountPrice}
                                        </span>
                                        <span
                                            style={{
                                                backgroundColor: "#fef3c7",
                                                color: "#d97706",
                                                padding: "4px 10px",
                                                borderRadius: "9999px",
                                                fontSize: "0.875rem",
                                                fontWeight: "500",
                                            }}
                                        >
                                            Save {program.discountPercentage || "37%"}
                                        </span>
                                    </>
                                )}
                            </div>

                            {/* Skills Section */}
                            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                {program.skills?.split(",").map((skill, skillIndex) => (
                                    <span
                                        key={skillIndex}
                                        style={{
                                            padding: "4px 8px",
                                            backgroundColor: "#E0E7FF",
                                            color: "#3B82F6",
                                            borderRadius: "12px",
                                            fontSize: "12px",
                                        }}
                                    >
                                        {skill.trim()}
                                    </span>
                                ))}
                            </div>


                            {program.startDate && (
                                <div>
                                    <p style={{ fontWeight: "500" }}>Starting On</p>
                                    <p style={{ fontSize: "1.125rem", color: "#2563eb" }}>
                                        {program.startDate}
                                    </p>
                                </div>
                            )}


                            <div className="button_submit">
                                <h1>{program?.is_enrolled}</h1>
                                <button  onClick={() =>  program?.is_enrolled === false ?courseEnrollment(userId, program.id,1):alert('Program is already Applied ')}
                                    style={{
                                        width: "200px",
                                        backgroundColor: program?.is_enrolled === true ? "#e0e0e0" : "#10b981",
                                        color: "#ffffff",
                                        padding: "12px 20px",
                                        marginTop: "10px",
                                        border: "none",
                                        borderRadius: "8px",
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                    // onMouseOver={(e) =>
                                    //     (e.currentTarget.style.backgroundColor = "#059669")
                                    // }
                                    // onMouseOut={(e) =>
                                    //     (e.currentTarget.style.backgroundColor = "#10b981")
                                    // }
                                >
                                    {program.is_enrolled===true?'Enrolled' : 'Enroll Now'}
                                </button>
                            </div>
                        </div>
                    }

                </div>


                <div
                    style={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "8px",
                    }}
                >
                    <img
                        src={NOCourses}
                        alt="No Courses Available"
                        style={{ width: "100%", height: "auto" }}
                    />
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
    const { universityCourseEnrollment } = actions;
    return {

        universityCourseEnrollment: (user_id, program_id,enroll_status) => dispatch(universityCourseEnrollment(user_id, program_id,enroll_status)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProgramDetails);
